import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from '@reach/router'

// icons
// import { Barcode } from '@styled-icons/boxicons-regular/Barcode'
import { PeopleFill } from '@styled-icons/bootstrap'
import { Settings } from 'styled-icons/ionicons-outline'
// import { Team } from '@styled-icons/remix-fill'

// utils
import th from 'utils/themeHelper'

// styles
import DashCardWrapper from './DashCardWrapper'

// import { FileInvoiceDollar } from '@styled-icons/fa-solid/FileInvoiceDollar'
import { AdminPanelSettings } from '@styled-icons/material/AdminPanelSettings'
import { PeopleFill as People } from '@styled-icons/bootstrap'
// import { BuildingHouse } from '@styled-icons/boxicons-regular/BuildingHouse'
// import { Handshake } from '@styled-icons/fa-solid/Handshake'

const baseIconStyles = css`
  background: ${props => props.background};
  border-radius: ${props => (props.background ? '50%' : '0')};
  color: ${th('borders.dark')};
  height: 20px;
  padding: 2px;
  width: 20px;
`

const AdminPanelIcon = styled(AdminPanelSettings)`
  ${baseIconStyles}
`

// const BuildingHouseIcon = styled(BuildingHouse)`
//   ${baseIconStyles}
// `

// const FileInvoice = styled(FileInvoiceDollar)`
//   ${baseIconStyles}
// `

// const HandshakeIcon = styled(Handshake)`
//   ${baseIconStyles}
// `

const PeopleIcon = styled(People)`
  ${baseIconStyles}
`

// const ReceiptIcon = styled(Receipt)`
//   ${baseIconStyles}
// `

const Avatar = styled.img`
  border-radius: 50%;
  height: 20px;
  width: 20px;
`

const ActionItem = styled.div`
  margin-right: 10px;
  margin-top: 15px;

  &:last-of-type {
    margin-right: 0;
  }
`

const Actions = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 10px;
`

const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const TeamCardLink = styled(Link)`
  border-color: ${th('backgrounds.mid')};
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  color: ${th('text.dark')};
  margin: 0;
  padding: 8px 12px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;

  & > svg {
    width: 15px;
    margin-right: 10px;
  }

  @media screen and (max-width: 400px) {
    padding: 6px 8px;
    font-size: 12px;

    & > svg {
      width: 12px;
      margin-right: 6px;
    }
  }
`

const Info = styled.div`
  display: block;
  margin: 10px 15px 0;
  flex: 1;
`

const InfoFieldLabel = styled.div`
  font-family: ${th('fonts.bold')};
  margin-right: 10px;
`

const InfoFieldValue = styled.div`
  font-family: ${th('fonts.regular')};
  margin-left: 30px;
`

const InfoFieldIcon = styled.div`
  margin-right: 10px;

  & > svg {
    height: 20px;
  }
`

const InfoGroup = styled.div`
  min-width: 30%;
`

const InfoGroupRow = styled.div`
  color: ${th('text.mid')};
  line-height: 1.25em;
  margin-bottom: 15px;
`

const InfoGroupRowInner = styled.div`
  display: flex;
  word-break: break-word;
`

const DashPartnerCard = ({
  avatar,
  id,
  name,
  participants_count,
  projects_count,
  worksites_count
}) => {
  return (
    <DashCardWrapper>
      <ActionsWrapper>
        <Info>
          <InfoGroup>
            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <Avatar src={avatar} />
                </InfoFieldIcon>
                <InfoFieldLabel>Partner</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{name}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <AdminPanelIcon background="gold" />
                </InfoFieldIcon>
                <InfoFieldLabel>Participants</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{participants_count}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <AdminPanelIcon background="#379b7550" />
                </InfoFieldIcon>
                <InfoFieldLabel>Worksites</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{worksites_count}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>

            <InfoGroupRow>
              <InfoGroupRowInner>
                <InfoFieldIcon>
                  <PeopleIcon />
                </InfoFieldIcon>
                <InfoFieldLabel>Projects</InfoFieldLabel>
              </InfoGroupRowInner>

              <InfoGroupRowInner>
                <InfoFieldValue>{projects_count}</InfoFieldValue>
              </InfoGroupRowInner>
            </InfoGroupRow>
          </InfoGroup>
        </Info>

        <Actions>
          <ActionItem>
            <TeamCardLink to={`/dashboard/participants?oid=${id}`}>
              <PeopleFill />
              <span>Participants</span>
            </TeamCardLink>
          </ActionItem>

          <ActionItem>
            <TeamCardLink to={`/dashboard/admins?oid=${id}`}>
              <PeopleFill />
              <span>Admins</span>
            </TeamCardLink>
          </ActionItem>

          <ActionItem>
            <TeamCardLink to={`/dashboard/partners/${id}`}>
              <Settings />
              <span>Edit</span>
            </TeamCardLink>
          </ActionItem>
        </Actions>
      </ActionsWrapper>
    </DashCardWrapper>
  )
}

export default DashPartnerCard
